/**
 * Utility functions for ProfileConfigurationCenter
 */

export { getFullUrl as getImageUrl } from '../../utils/url';

/**
 * Get gradient classes based on color scheme
 */
export const getGradientClasses = (colorScheme: string): string => {
  const gradients: Record<string, string> = {
    blue: 'from-blue-600 to-indigo-600',
    green: 'from-green-600 to-emerald-600',
    purple: 'from-purple-600 to-pink-600',
    orange: 'from-orange-500 to-amber-600',
    red: 'from-red-600 to-orange-600',
    gray: 'from-gray-500 to-slate-600'
  };
  return gradients[colorScheme] || gradients.blue;
};

/**
 * Get photo gradient classes based on color scheme
 */
export const getPhotoGradientClasses = (colorScheme: string): string => {
  const gradients: Record<string, string> = {
    blue: 'from-blue-500 to-indigo-600',
    green: 'from-green-500 to-emerald-600',
    purple: 'from-purple-500 to-pink-600',
    orange: 'from-orange-500 to-amber-600',
    red: 'from-red-500 to-orange-600',
    gray: 'from-gray-500 to-slate-600'
  };
  return gradients[colorScheme] || gradients.blue;
};

/**
 * Generate vCard data from profile information
 */
export const generateVCardData = (
  firstName: string,
  lastName: string,
  jobTitle: string,
  email: string,
  phone: string,
  profileUrl: string
): string => {
  return `BEGIN:VCARD
VERSION:3.0
FN:${firstName} ${lastName}
N:${lastName};${firstName};;;
TITLE:${jobTitle}
ORG:Mowazaf
EMAIL:${email}
TEL:${phone}
URL:${profileUrl}
END:VCARD`;
};

/**
 * Download vCard file
 */
export const downloadVCard = (
  firstName: string,
  lastName: string,
  jobTitle: string,
  email: string,
  phone: string,
  profileUrl: string
): void => {
  const vCardData = generateVCardData(firstName, lastName, jobTitle, email, phone, profileUrl);
  const blob = new Blob([vCardData], { type: 'text/vcard' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${firstName}_${lastName}.vcf`;
  link.click();
  window.URL.revokeObjectURL(url);
};

/**
 * Copy text to clipboard
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Failed to copy:', error);
    return false;
  }
};
